<template>
  <el-row style="padding-bottom: 5px;">
    <el-col
      :span="24"
      class="actions-top"
    >
      <div class="list-header">
        <slot name="sls-header-before" />
      </div>
      <el-button
        v-if="btn_info.batch!==false && btn_info.batch_delete!==false"
        type="danger"
        icon="Delete"
        :disabled="batch.flag"
        :plain="StylePlain"
        @click="onBtnEvent({type:'BatchDelete'})"
      >
        {{ btn_info.batch_delete_text || 'Apagar' }}{{ batch.ids.length ? '('+batch.ids.length+')' : '' }}
      </el-button>

      <el-button
        v-if="btn_info.add!==false"
        type="primary"
        icon="Plus"
        title="Novo Registro"
        :plain="StylePlain"
        @click="onBtnEvent({type:'Add'})"
      >
        {{ btn_info.add_text || 'Novo' }}
      </el-button>

      <el-button
        v-if="btn_info.search_panel && btn_info.search_panel !== false"
        type="primary"
        title="Exibir/Ocultar Painel Filtro de Busca"
        :plain="StylePlain"
        @click="onSearchPanel"
      >
        <font-awesome-icon icon="search-plus" />
      </el-button>

      <el-button
        v-if="btn_info.batch!==false && btn_info.batch_add!==false"
        type="primary"
        :icon="btn_info.batch_add_icon ? btn_info.batch_add_icon : 'Plus'"
        :disabled="batch.flag"
        :plain="StylePlain"
        @click="onBtnEvent({type:'BatchAdd'})"
      >
        {{ btn_info.batch_add_text || 'Adicionar' }}{{ batch.ids.length ? '('+batch.ids.length+')' : '' }}
      </el-button>

      <el-button
        v-if="btn_info.batch!==false && btn_info.batch_update!==false"
        type="primary"
        :icon="btn_info.batch_update_icon? btn_info.batch_update_icon : 'Edit'"
        :disabled="batch.flag"
        :plain="StylePlain"
        @click="onBtnEvent({type:'BatchUpdate'})"
      >
        {{ btn_info.batch_update_text || 'Atualizar' }}{{ batch.ids.length ? '('+batch.ids.length+')' : '' }}
      </el-button>

      <el-button
        v-if="btn_info.custom_delete === true"
        type="danger"
        icon="Delete"
        :disabled="btn_info.custom_delete_disable"
        :plain="StylePlain"
        @click="onBtnEvent({type:'CustomDelete'})"
      >
        {{ btn_info.custom_delete_text || 'Apagar' }}
      </el-button>

      <el-button
        v-if="btn_info.custom_search === true"
        type="primary"
        :disabled="btn_info.custom_search_disable"
        :plain="StylePlain"
        @click="onBtnEvent({type:'CustomSearch'})"
      >
        <font-awesome-icon icon="search-plus" /> {{ btn_info.custom_search_text || 'Buscar' }}
      </el-button>

      <el-button
        v-if="btn_info.custom_button === true"
        type="primary"
        :disabled="btn_info.custom_button_disable"
        :plain="StylePlain"
        @click="onBtnEvent({type:'CustomButton'})"
      >
        {{ btn_info.custom_button_text || 'Executar' }}
      </el-button>

      <div class="list-header">
        <slot name="sls-header-after" />
      </div>

      <div
        v-if="fields && fields.length"
        class="list-search"
      >
        <form-data
          :Setting="setting"
          :FieldList="fields"
          :DefaultValue="default_value"
          :StylePlain="StylePlain"
          @on-submit="onSearch"
        />
      </div>
    </el-col>
  </el-row>
</template>
<script>
import {
  useEventBus,
} from 'apsis-plugin';
import FormData from '../formdata';

export default {
  components: { FormData },

  props: {
    Batch: {
      type: Object,
      default() {
        return {};
      },
    },
    BtnInfo: {
      type: Object,
      default() {
        return {};
      },
    },
    Search: {
      type: Object,
      default() {
        return {};
      },
    },
    StylePlain: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  emits: ['onBtnEvent', 'onSearch'],
  setup() {
    const { emitEvent } = useEventBus();
    return { emitEvent };
  },
  computed: {
    batch() {
      return this.Batch || {};
    },
    btn_info() {
      return this.BtnInfo || {};
    },
    fields() {
      return this.Search.fields || [];
    },
    default_value() {
      return this.Search.default_value || {};
    },
    setting() {
      return this.Search.setting || { inline: true };
    },
  },
  methods: {
    onBtnEvent(opts) {
      this.$emit('onBtnEvent', opts);
    },
    onSearch(opts) {
      this.$emit('onSearch', opts);
    },
    onSearchPanel() {
      this.emitEvent('searchpanel.called');
    },
  },
};
</script>

<style scoped lang='less'>
  .list-header {
    display: inline-block;
  }

  .list-search {
    display: inline-block;
  }
</style>
